var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded && this.isMobile
    ? _c(
        "div",
        {
          staticClass: "mobile_add_to_cart_wrapper",
          attrs: { id: "mobile_add_to_cart_wrapper" },
        },
        [
          _vm.upstreamConnectionFailure
            ? _c(
                "span",
                {
                  staticClass: "product-aside-heading-upsteam-connection-error",
                },
                [
                  _vm._v(
                    "\n    ⚠️ There is currently an issue connecting to the stock control system. Please enter your email below and we can alert you as soon as this is resolved.\n  "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEnquireNow && !_vm.isComingSoon
            ? _c(
                "div",
                {
                  staticClass: "product-aside-cart-container",
                  staticStyle: {
                    position: "fixed",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    "min-height": "99px",
                    height: "auto",
                    display: "flex",
                    "flex-direction": "column",
                    "align-items": "center",
                    padding: "20px",
                    "margin-bottom": "0",
                    "z-index": "1000",
                  },
                  attrs: { "data-test": "enquire_now" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn--product-aside product-aside-enquire-now",
                      attrs: { id: "enquireNowSleek" },
                    },
                    [_vm._v("REGISTER YOUR INTEREST")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showProductActions
            ? _c(
                "div",
                [
                  (_vm.isOutOfStock || _vm.isComingSoon) &&
                  _vm.product.shopify_metafields.notify_me_block &&
                  !_vm.isEnquireNow
                    ? _c("outOfStock", {
                        attrs: {
                          product_id: _vm.id,
                          variants: _vm.product.product_variants,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAddToCart &&
                  !_vm.isOutOfStock &&
                  !_vm.isComingSoon &&
                  !_vm.product.shopify_metafields.engraving.available &&
                  !_vm.isEnquireNow
                    ? _c("addToCart", {
                        attrs: {
                          id: _vm.id,
                          available: !_vm.isOutOfStock && !_vm.isComingSoon,
                          product: _vm.product,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.product.shopify_metafields.engraving.available &&
                  !_vm.isComingSoon &&
                  !_vm.isEnquireNow
                    ? _c("addToCart", {
                        attrs: {
                          id: _vm.id,
                          engravingProduct:
                            _vm.product.shopify_metafields.engraving.product,
                          engravingAvailable:
                            _vm.product.shopify_metafields.engraving.available,
                          available: !_vm.isOutOfStock && !_vm.isComingSoon,
                          product: _vm.product,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCorporateMessage
            ? _c("div", [_c("p", [_vm._v("Corporate exclusive.")])])
            : _vm._e(),
          _vm._v(" "),
          _vm.showB2BMessage
            ? _c("div", [
                _c("p", [_vm._v("Not available for corporate orders.")]),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }